"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EmailInput = _interopRequireDefault(require("./EmailInput"));
var _shareRecommendationSelectors = require("../../store/shareRecommendation/shareRecommendationSelectors");
var _EmailError = _interopRequireDefault(require("./EmailError"));
var _EmailSuccess = _interopRequireDefault(require("./EmailSuccess"));
var _useAppSelector = require("../../hooks/useAppSelector");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ShareRecommendation = () => {
  const {
    error,
    isSent
  } = (0, _useAppSelector.useAppSelector)(_shareRecommendationSelectors.selectSendRecommendationStatues);
  if (!error && !isSent) return /*#__PURE__*/_react.default.createElement(_EmailInput.default, null);
  if (isSent) return /*#__PURE__*/_react.default.createElement(_EmailSuccess.default, null);
  if (error) return /*#__PURE__*/_react.default.createElement(_EmailError.default, null);
};
var _default = ShareRecommendation;
exports.default = _default;